// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CardList-scrollContainer__OcvhL{display:flex;flex-direction:column;align-items:center;width:var(--size-full);margin-bottom:var(--bottom-bar-height);padding:var(--size-4) var(--size-4) 0;overflow:auto}.CardList-virtualizer__kPlij{position:relative;width:var(--size-full)}.CardList-cardContainer__mSePM{position:absolute;top:var(--size-0);left:var(--size-0);width:var(--size-full);max-width:calc(var(--size-110) + var(--size-7_5)*2);padding-bottom:var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollContainer": "CardList-scrollContainer__OcvhL",
	"virtualizer": "CardList-virtualizer__kPlij",
	"cardContainer": "CardList-cardContainer__mSePM"
};
export default ___CSS_LOADER_EXPORT___;
